import { MessageCircle, BadgeCheck, MapPin } from "lucide-react";
import { resolveImage, whatsappLink } from "@/lib/api";
import { useSettings } from "@/hooks/useSettings";

export function ResellerCard({ reseller }) {
  const s = useSettings();
  const message = (s.whatsapp_message || "Hello, I want to recharge my Golden Live ID.");
  const link = whatsappLink(reseller.country_code, reseller.whatsapp_number, message);

  return (
    <div
      className="card-surface group relative flex flex-col items-center rounded-2xl p-6 text-center transition-all duration-300 hover:-translate-y-1 hover:gold-glow"
      data-testid={`reseller-card-${reseller.id}`}
    >
      <div className="relative">
        <div className="h-24 w-24 overflow-hidden rounded-full ring-2 ring-gold/40">
          {reseller.image_url ? (
            <img src={resolveImage(reseller.image_url)} alt={reseller.name} className="h-full w-full object-cover" />
          ) : (
            <div className="flex h-full w-full items-center justify-center bg-obsidian-elevated font-display text-3xl gold-text">
              {reseller.name?.[0] || "G"}
            </div>
          )}
        </div>
        <span className="absolute -bottom-1 -right-1 flex h-7 w-7 items-center justify-center rounded-full bg-obsidian ring-2 ring-gold/40">
          <BadgeCheck className="h-4 w-4 text-gold" />
        </span>
      </div>

      <h3 className="mt-4 text-lg font-bold text-slate-100">{reseller.name}</h3>
      {reseller.reseller_id && (
        <p className="mt-0.5 font-mono text-xs text-gold">ID: {reseller.reseller_id}</p>
      )}
      {reseller.country && (
        <p className="mt-1 inline-flex items-center gap-1 text-xs text-slate-400">
          <MapPin className="h-3.5 w-3.5" /> {reseller.country}
        </p>
      )}

      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        data-testid={`reseller-whatsapp-button-${reseller.id}`}
        className="mt-5 flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-whatsapp text-base font-bold text-white transition-colors hover:bg-whatsapp-hover"
      >
        <MessageCircle className="h-5 w-5" /> Chat on WhatsApp
      </a>
    </div>
  );
}
